<template>
  <base-page-layout id="cupons-desconto" title="Cupons de desconto" :flow-id="flowId" show-tour :loading-tutorial="loadingTutorial">
    <div class="tabs-button-header">
      <mf-tabs-menu v-model="tab" :tabs="tabs" />
      <div v-if="!isFranchisee" class="tab-buttons" data-userflow-id="new-coupon-discount">
        <mf-button id="cupons-desconto-new-campaign" icon="add" label="Nova campanha" @click="newCampaign" />
      </div>
    </div>

    <div data-userflow-id="coupon-discount-index-table">
      <campaigns-table v-if="tab === 0" :items-filter="isFranchisee ? filterListFranchisee : filterList" />
      <campaigns-table v-else history />
    </div>
  </base-page-layout>
</template>

<script>
import BasePageLayout from '@/components/BasePageLayout.vue'
import CampaignsTable from '../components/index/CampaignsTable.vue'
import { getStatusLabel } from '@/config/helpers.js'
export default {
  name: 'CoupomDiscount',
  components: {
    BasePageLayout,
    CampaignsTable,
  },
  data: () => ({
    tab: 0,
    loadingTutorial: false,
    filterList: [
      { label: getStatusLabel('ACTIVE').text, value: 'ACTIVE', color: getStatusLabel('ACTIVE').color, active: true },
      { label: getStatusLabel('SCHEDULED').text, value: 'SCHEDULED', color: getStatusLabel('SCHEDULED').color, active: true },
      { label: getStatusLabel('DRAFT').text, value: 'DRAFT', color: getStatusLabel('DRAFT').color, active: true },
    ],
    filterListFranchisee: [
      { label: getStatusLabel('ACTIVE').text, value: 'ACTIVE', color: getStatusLabel('ACTIVE').color, active: true },
      { label: getStatusLabel('SCHEDULED').text, value: 'SCHEDULED', color: getStatusLabel('SCHEDULED').color, active: true },
    ],
  }),
  computed: {
    isFranchisee() {
      return this.$getLoggedUser().is_franchisee
    },
    flowId() {
      const franchiseeFlowId = 'c8292498-6d2a-424f-bc15-e547a0863442'
      const flowId = 'ebf119eb-8912-4464-801c-e840d4ae7bb8'
      return this.isFranchisee ? franchiseeFlowId : flowId
    },
    tabs() {
      return [
        {
          name: 'Campanhas ativas',
          itemsLength: 0,
          haveLength: false,
        },
        {
          name: 'Histórico',
          itemsLength: 0,
          haveLength: false,
        },
      ]
    },
  },
  methods: {
    newCampaign() {
      this.$router.push({ name: 'cupom-desconto-nova' })
    },
  },
}
</script>

<style lang="scss" scoped>
.tabs-button-header {
  position: relative;
  margin-bottom: 20px;
  .tab-buttons {
    position: absolute;
    top: 5px;
    right: 0;
  }
}
</style>
